import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Kontakt"),
  /*#__PURE__*/_createElementVNode("p", null, "info@nightbane.de"),
  /*#__PURE__*/_createElementVNode("form", null, [
    /*#__PURE__*/_createElementVNode("label"),
    /*#__PURE__*/_createElementVNode("input", { type: "text" })
  ])
], -1)

import TextPageLayout from '@/components/text-page-layout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextPageLayout, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})